__turbopack_context__.v({
  "radio": "radio-module-scss-module__IVjT5W__radio",
  "radioItem": "radio-module-scss-module__IVjT5W__radioItem",
});
